import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoginService } from '../../core/login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../core/auth/account.service';
import { SessionStorageService } from "ngx-webstorage";
import { AuthenticationInput } from '../../core/login/authentication-input.model';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from '../../core/user/user.service';
import { LeaveNumberModalComponent } from './leave-number-modal.component';
import { ErrorHandlerService } from '../../core/error/error-handler.service';
import { RegistrationService } from '../registration/registration.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/login/login.service";
import * as i2 from "@angular/router";
import * as i3 from "@angular/forms";
import * as i4 from "../../core/auth/account.service";
import * as i5 from "ngx-webstorage";
import * as i6 from "../../ng-jhipster/language";
import * as i7 from "../../ng-jhipster/service";
import * as i8 from "@ng-bootstrap/ng-bootstrap";
import * as i9 from "../../core/user/user.service";
import * as i10 from "../../core/error/error-handler.service";
import * as i11 from "../registration/registration.service";
import * as i12 from "../../shared/unauth-header/unauth-header.component";
import * as i13 from "../../shared/util/long-press.directive";
import * as i14 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i15 from "@angular/material/form-field";
import * as i16 from "@angular/material/input";
import * as i17 from "@angular/material/button";
import * as i18 from "@angular/material/icon";
import * as i19 from "@angular/common";
import * as i20 from "../../shared/track-user-activity.directive";
import * as i21 from "@ngx-translate/core";
function LoginComponent_mat_form_field_27_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 13);
    i0.ɵɵelementStart(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 49);
    i0.ɵɵlistener("click", function LoginComponent_mat_form_field_27_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.errorMessage = null; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "login.form.otp"));
} }
const _c0 = function () { return { "track": "click", name: "login_btn_clicked" }; };
const _c1 = function () { return { "track": "click", name: "magic_login_btn_clicked" }; };
export class LoginComponent {
    constructor(loginService, router, formBuilder, accountService, elementRef, activatedRoute, sessionStorage, languageService, eventManager, modalService, userService, errorHandlerService, registrationService) {
        this.loginService = loginService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.accountService = accountService;
        this.elementRef = elementRef;
        this.activatedRoute = activatedRoute;
        this.sessionStorage = sessionStorage;
        this.languageService = languageService;
        this.eventManager = eventManager;
        this.modalService = modalService;
        this.userService = userService;
        this.errorHandlerService = errorHandlerService;
        this.registrationService = registrationService;
        this.eyeSlashed = false;
        this.typeInput = 'password';
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.displayNLHelpHeader = false;
        this.loginForm = this.formBuilder.group({ email: [''], password: [''], rememberMe: [false], otp: [''] });
        this.otpRequired = false;
        this.hide = true;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
        if (this.accountService.isAuthenticated()) {
            this.loginService.redirectToHomepage();
        }
        let emailFromUrl = this.activatedRoute.snapshot.queryParams["email"];
        this.loginForm.get('email').setValue(emailFromUrl);
        this.getLoginRegion();
    }
    getLoginRegion() {
        this.userService.getLoginCountry().subscribe(regionResponse => {
            console.log(regionResponse);
            if (regionResponse === 'Netherlands')
                this.displayNLHelpHeader = true;
        }, regionError => {
            console.log(regionError);
        });
    }
    displayErrorModal() {
        const modalRef = this.modalService.open(LeaveNumberModalComponent, this.modalOptions);
        modalRef.componentInstance.leaveNumberModalRef = modalRef;
        modalRef.componentInstance.displayNLHelpHeader = this.displayNLHelpHeader;
        modalRef.componentInstance.errorMessage = this.errorMessage;
    }
    login() {
        this.email = this.loginForm.get('email').value;
        this.password = this.loginForm.get('password').value;
        let rememberMe = true; // this.loginForm.get('rememberMe')!.value;
        let otp = "";
        if (this.otpRequired) {
            otp = this.loginForm.get('otp').value;
            if (otp.length === 0) {
                this.errorMessage = 'register.messages.error.otpRequired';
                this.displayErrorModal();
                return;
            }
        }
        if (!this.email || this.email.length === 0 || !this.email.includes('@')
        // || !this.pattern.test(email)
        ) {
            this.errorMessage = 'register.messages.error.invalidEmail';
            this.displayErrorModal();
            return;
        }
        if (!this.password || this.password.length === 0) {
            this.errorMessage = 'login.messages.error.wrongEmail';
            this.displayErrorModal();
            return;
        }
        let credentials = new AuthenticationInput(this.email, this.password, rememberMe, otp);
        this.loginSubscription = this.loginService.login(credentials).subscribe(() => {
            // this.activeModal.close();
            if (this.router.url === '/account/register' || this.router.url.startsWith('/account/activate') || this.router.url.startsWith('/account/reset/')) {
                this.router.navigate(['']);
            }
            this.errorType = this.loginService.redirectToHomepage() ? 'INVALID_AUTHORITY' : '';
        }, (err) => {
            console.log("login error" + JSON.stringify(err));
            const problemDetail = this.errorHandlerService.problemDetail(err);
            if (problemDetail) {
                if (problemDetail.title === 'TwoFactorAuthenticationRequired') {
                    // this.errorMessage = 'login.messages.error.otpRequired';
                    this.otpRequired = true;
                    this.otp = problemDetail.detail;
                }
                else if (problemDetail.title === 'TwoFactorAuthenticationNotValid') {
                    this.errorMessage = 'login.messages.error.otpInvalid';
                    this.otpRequired = true;
                    this.displayErrorModal();
                }
                else if (problemDetail.title === 'Unauthorized') {
                    this.errorMessage = 'login.messages.error.wrongEmail';
                    this.displayErrorModal();
                }
                else if (problemDetail.title === 'LoginAttemptLimitExceeded') {
                    this.errorMessage = 'login.messages.error.attemptLimit';
                    this.displayErrorModal();
                }
                else {
                    // this.errorMessage = 'login.messages.error.forbidden';
                    this.errorHandlerService.handleError(err);
                }
                return;
            }
            else {
                console.log('Unspecified error: ' + err);
                this.errorMessage = 'login.messages.error.unspecifiedError';
                this.displayErrorModal();
            }
        });
    }
    onTogglePassword() {
        this.eyeSlashed = !this.eyeSlashed;
        this.typeInput === 'text' ? (this.typeInput = 'password') : (this.typeInput = 'text');
    }
    ngOnDestroy() {
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
    }
    toggleConsoleLogViewer() {
        this.eventManager.broadcast('toggleConsoleLogViewer');
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.FormBuilder), i0.ɵɵdirectiveInject(i4.AccountService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i5.SessionStorageService), i0.ɵɵdirectiveInject(i6.JhiLanguageService), i0.ɵɵdirectiveInject(i7.JhiEventManager), i0.ɵɵdirectiveInject(i8.NgbModal), i0.ɵɵdirectiveInject(i9.UserService), i0.ɵɵdirectiveInject(i10.ErrorHandlerService), i0.ɵɵdirectiveInject(i11.RegistrationService)); };
LoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["jhi-login"]], decls: 71, vars: 17, consts: [[1, "olha-theme"], [1, "container"], [1, "row", "justify-content-center"], [1, "d-none", "d-lg-block", "col-lg-6", "p-0", "pr-3"], [1, "image-div"], ["src", "../../../../content/images/inuka-forest.svg", "alt", "inuka-forest.svg", "width", "100%"], [1, "col-sm-12", "col-lg-6", "p-0"], [1, "text-center", "bg-2", "form-div"], ["longPress", "", 1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "text-center", 3, "mouseLongPress"], ["src", "../../../../content/images/inuka-logo-top.svg", "alt", "inuka-logo-top", "width", "70"], ["jhiTranslate", "login.welcomeBack", 1, "my-3"], ["name", "form", "role", "form", 3, "formGroup", "ngSubmit"], [1, "d-flex", "flex-column", "form-inside"], ["appearance", "outline"], ["matInput", "", "name", "email", "id", "email", "formControlName", "email"], ["matInput", "", "name", "password", "id", "password", "formControlName", "password", 3, "type"], ["mat-icon-button", "", "matSuffix", "", "type", "button", 3, "click"], ["inline", "true"], ["appearance", "outline", 4, "ngIf"], [1, "form-text", "text-danger"], [1, "text-right"], ["routerLink", "/forgot-password", "jhiTranslate", "login.password.forgot", 1, "btn-link", "forgot-password"], [1, "text-center", "d-flex", "justify-content-center", "align-items-center", "flex-column", "flex-xl-row", "flex-xl-row-reverse"], ["id", "login-submit-btn", "type", "submit", "jhiTranslate", "login.form.logIn", 1, "btn", "btn-primary", "login-button", "mt-4", 3, "trackUserActivity"], ["jhiTranslate", "login.form.magicLogin", "routerLink", "/magic-login", 1, "btn", "btn-secondary", "login-button", "mt-4", "mr-xl-3", 2, "padding-top", "10px", 3, "trackUserActivity"], [1, "new-here"], ["jhiTranslate", "login.newHere", 1, "pr-1"], ["routerLink", "/register-new", "jhiTranslate", "login.signUp", 1, "btn-link"], [1, "inuka-services"], ["jhiTranslate", "login.inukaServices", 1, "pr-1"], ["href", "https://inukacoaching.com/resources/#more-support", "jhiTranslate", "login.resources", "target", "_blank", 1, "btn-link"], ["id", "smallmodal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "smallmodal", "aria-hidden", "true", 1, "modal", "fade"], ["role", "document", 1, "modal-dialog", "modal-sm"], [1, "modal-content"], [1, "modal-header"], ["id", "smallmodal1", "jhiTranslate", "login.incorrect", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], ["jhiTranslate", "login.messages.error.wrongEmail"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", "jhiTranslate", "login.close", 1, "btn", "btn-secondary"], ["id", "enterpinmodal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "enterpinmodal", "aria-hidden", "true", 1, "modal", "fade"], ["jhiTranslate", "login.one", 1, "modal-title"], ["jhiTranslate", "login.sendPin"], ["type", "text", "id", "pincode"], ["type", "button", "onClick", "checkPin();", "jhiTranslate", "login.confirmPin", 1, "btn", "btn-primary"], ["id", "loading-spinner"], [1, "fa", "fa-cog", "fa-spin", "fa-3x", "fa-fw", 2, "width", "80px", "margin", "0 auto", "line-height", "80px", "vertical-align", "middle"], ["matInput", "", "name", "otp", "id", "otp", "formControlName", "otp", 3, "click"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "unauth-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "img", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵlistener("mouseLongPress", function LoginComponent_Template_div_mouseLongPress_9_listener() { return ctx.toggleConsoleLogViewer(); });
        i0.ɵɵelement(10, "img", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "h3", 10);
        i0.ɵɵelementStart(12, "form", 11);
        i0.ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_12_listener() { return ctx.login(); });
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵelementStart(14, "mat-form-field", 13);
        i0.ɵɵelementStart(15, "mat-label");
        i0.ɵɵtext(16);
        i0.ɵɵpipe(17, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "mat-form-field", 13);
        i0.ɵɵelementStart(20, "mat-label");
        i0.ɵɵtext(21);
        i0.ɵɵpipe(22, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "input", 15);
        i0.ɵɵelementStart(24, "button", 16);
        i0.ɵɵlistener("click", function LoginComponent_Template_button_click_24_listener() { return ctx.hide = !ctx.hide; });
        i0.ɵɵelementStart(25, "mat-icon", 17);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, LoginComponent_mat_form_field_27_Template, 5, 3, "mat-form-field", 18);
        i0.ɵɵelementStart(28, "div", 19);
        i0.ɵɵelementStart(29, "span");
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 20);
        i0.ɵɵelement(32, "a", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 22);
        i0.ɵɵelement(34, "button", 23);
        i0.ɵɵelement(35, "a", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 25);
        i0.ɵɵelement(37, "span", 26);
        i0.ɵɵelement(38, "a", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 28);
        i0.ɵɵelement(40, "span", 29);
        i0.ɵɵelement(41, "a", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 31);
        i0.ɵɵelementStart(43, "div", 32);
        i0.ɵɵelementStart(44, "div", 33);
        i0.ɵɵelementStart(45, "div", 34);
        i0.ɵɵelement(46, "h5", 35);
        i0.ɵɵelementStart(47, "button", 36);
        i0.ɵɵelementStart(48, "span", 37);
        i0.ɵɵtext(49, "\u00D7");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 38);
        i0.ɵɵelement(51, "p", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "div", 40);
        i0.ɵɵelement(53, "button", 41);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 42);
        i0.ɵɵelementStart(55, "div", 32);
        i0.ɵɵelementStart(56, "div", 33);
        i0.ɵɵelementStart(57, "div", 34);
        i0.ɵɵelement(58, "h5", 43);
        i0.ɵɵelementStart(59, "button", 36);
        i0.ɵɵelementStart(60, "span", 37);
        i0.ɵɵtext(61, "\u00D7");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(62, "div", 38);
        i0.ɵɵelement(63, "p", 44);
        i0.ɵɵtext(64, " PIN : ");
        i0.ɵɵelement(65, "input", 45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "div", 40);
        i0.ɵɵelement(67, "button", 41);
        i0.ɵɵelement(68, "button", 46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(69, "div", 47);
        i0.ɵɵelement(70, "i", 48);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("formGroup", ctx.loginForm);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 11, "login.form.emailAddress"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 13, "login.form.password"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("type", ctx.hide ? "password" : "text");
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx.hide);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.hide ? "visibility_off" : "visibility");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.otpRequired);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.otp);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(15, _c0));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(16, _c1));
    } }, directives: [i12.UnauthHeaderComponent, i13.LongPressDirective, i14.JhiTranslateDirective, i3.ɵNgNoValidate, i3.NgControlStatusGroup, i3.FormGroupDirective, i15.MatFormField, i15.MatLabel, i16.MatInput, i3.DefaultValueAccessor, i3.NgControlStatus, i3.FormControlName, i17.MatButton, i15.MatSuffix, i18.MatIcon, i19.NgIf, i2.RouterLinkWithHref, i20.TrackUserActivityDirective], pipes: [i21.TranslatePipe], styles: [".parent-container[_ngcontent-%COMP%]{margin:30px auto !important}.image-div[_ngcontent-%COMP%]{height:100% !important;padding:0 !important;margin:0 !important;display:flex;align-items:flex-end}.form-div[_ngcontent-%COMP%]{padding:20px !important;margin-left:10px !important;margin-right:10px !important}.form-inside[_ngcontent-%COMP%]{margin:0 !important}.footer-height[_ngcontent-%COMP%]{height:10px}.login-button[_ngcontent-%COMP%]{width:250px;height:50px;margin-top:30px}.new-here[_ngcontent-%COMP%]{color:#0a4a3a;font-weight:600;margin-top:20px}.inuka-services[_ngcontent-%COMP%]{color:#0a4a3a;font-weight:400;margin-top:20px;font-size:12px}fa-icon.eye[_ngcontent-%COMP%]{font-size:18px;top:7px}.forgot-password[_ngcontent-%COMP%]{text-decoration:none !important;font-weight:normal !important}@media(min-width: 992px){.parent-container[_ngcontent-%COMP%]{margin:50px auto !important}.form-div[_ngcontent-%COMP%]{padding:30px !important;margin-left:0 !important;margin-right:0 !important}.login-button[_ngcontent-%COMP%]{width:250px;height:50px}}"] });
